import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComunicacionService {

@Output() enviarDataSubject = new EventEmitter<any>();
  data: any;

  enviarData(data: any) {
    this.data = data;
    this.enviarDataSubject.emit(data);
  }
}
